import React from 'react';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import Controller from './CampaignDetailsCreativeController';
import CURRENT_USER from '../../../../GraphQl/Queries/CURRENT_USER';

const CampaignDetailsCreativeLoader = ({ children, ...props }) => {
  return <Controller {...props}>{children}</Controller>;
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(CampaignDetailsCreativeLoader);
